import styled from "styled-components";

const CustomTooltip = styled.div`
  background-color: white;
  padding: 6px 10px;
  border-radius: 4px;
  box-shadow: 0px 4px 12px rgba(34, 37, 41, 0.12);

  font-size: 12px;
  font-weight: 400;
  color: #4a5056;

  .intro {
    color: #222529;
    font-size: 14px;
    font-weight: 700;
  }
`;

export { CustomTooltip };
